<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">科目汇总</span>
		</div>
		<div class="margin-right-left margin-top">
			<!-- <account-date-choose v-model="accountDate"/> -->
			时间：<a-range-picker :locale="locale" v-model="dp"  @change="onTimeChange" />&nbsp;
			科目：<a-select v-model="subjectId" style="width:280px" @change="subjectSelect" :options="subjectData" show-search :filter-option="filterOption" :allowClear='true'></a-select>
			<div class="float-right">
				<!-- <Checkbox v-model="showNumPrice">显示数量金额</Checkbox> -->
			</div>
		</div>
		<div class="h-panel-body" type="flex" :space-x="10">
			<table class="balance" v-if="!showNumPrice">
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td colspan="2">金额合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="4" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
			<table class="balance" v-else>
				<thead class="header">
				<tr>
					<td rowspan="2" v-width="100">科目编码</td>
					<td rowspan="2" v-width="200">科目名称</td>
					<td rowspan="2" v-width="100">计量单位</td>
					<td colspan="2">金额合计</td>
					<td colspan="2">数量合计</td>
				</tr>
				<tr>
					<td>借方</td>
					<td>贷方</td>
					<td>借方</td>
					<td>贷方</td>
				</tr>
				</thead>
				<tbody>
				<tr v-for="item in dataList" :key="item.subjecId">
					<td :style="{'padding-left':(item.level)*10+'px'}">{{item.code}}</td>
					<td :style="{'padding-left':(item.level)*10+'px'}"><span class="text-hover">{{item.name}}</span></td>
					<td class="text-center">{{item.unit}}</td>
					<td align="right">{{item.currentDebitAmount|numFormat}}</td>
					<td align="right">{{item.currentCreditAmount|numFormat}}</td>
					<td align="right">{{item.currentDebitAmountNum|numFormat}}</td>
					<td align="right">{{item.currentCreditAmountNum|numFormat}}</td>
				</tr>
				<tr v-if="!dataList.length">
					<td colspan="7" class="text-center padding">暂无数据</td>
				</tr>
				</tbody>
			</table>
		</div>
	</app-content>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
	export default {
		name: "SubjectSummary",
		data() {
			return {
				dataList: [],
				accountDate: null,
				showNumPrice: false,
				loading: false,
				locale,
				subjectData:[],
				startTime:undefined,
				endTime:undefined,
				dp:[],
				subjectId:undefined,
			}
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		created(){
			this.subjectLoad();
			this.loadList();
		},
		methods: {
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			loadList() {
				if(this.startTime==undefined ||this.startTime=='' || this.endTime==undefined || this.endTime==''){
					this.startTime =moment().startOf("month").format("YYYY-MM-DD");
					this.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.dp = [
						this.startTime,
						this.endTime
					];
				}
				this.loading = true;
				this.$api.accountbook.loadSubjectSummary2({
					startTime: this.startTime,
					endTime:this.endTime,
					showNumPrice: this.showNumPrice,
					subjectId:this.subjectId
				}).then(({data}) => {
					this.dataList = data;
				}).finally(() => {
					this.loading = false;
				})
			},
			//时间筛选
			onTimeChange(date, dateString){
				this.startTime = dateString[0];
				this.endTime = dateString[1];
				this.loadList();
			},
			subjectLoad() { 
				this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					this.voucherSelect = data;	
					this.$Loading.close(); 
					if(this.voucherSelect!=undefined && this.voucherSelect.length>0){
						for(var i = 0;i<this.voucherSelect.length;i++){
							var ops = {
								value:this.voucherSelect[i].id,
								label:this.voucherSelect[i].subjectFullName
							}
							this.subjectData.push(ops);
						}
					}
				});
			},
			subjectSelect(val,option){
				this.loadList();
			}
		}
	}
</script>

<style scoped lang="less">
	.balance {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #e2e2e2;
			font-size: 12px;
			height: 32px;

			&.tip {
				background-color: #FFEEEF;
			}
		}

		tbody tr:nth-child(even) {
			background-color: #f8fbf8;
		}

		tbody tr:hover {
			background-color: #F0F6FF;
		}

		.header {
			td {
				background-color: #F5F5F5;
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>